export default `:host {
  position: relative;
  width: 100%;
}

.ids-slider {
  display: flex;
  justify-content: center;
}
.ids-slider .tick {
  background-color: var(--ids-slider-tick-color-background-default);
}
.ids-slider .thumb-shadow {
  background-color: var(--ids-slider-thumb-color-shadow-default);
  border-color: var(--ids-slider-thumb-color-border-default);
}
.ids-slider .thumb {
  background-color: var(--ids-slider-thumb-color-background-default);
}
.ids-slider .thumb:hover {
  box-shadow: var(--ids-slider-thumb-shadow-hover);
}
.ids-slider .track {
  background-color: var(--ids-slider-track-color-background-default);
}
.ids-slider .track-progress {
  background-color: var(--ids-slider-track-color-background-progress);
}
.ids-slider:not(.vertical) {
  width: 100%;
}
.ids-slider:not(.vertical) .thumb {
  cursor: ew-resize;
}
.ids-slider.vertical {
  height: 300px;
}
.ids-slider.vertical .thumb {
  cursor: ns-resize;
}
.ids-slider.animated .thumb-draggable {
  transition: transform var(--ids-motion-duration) var(--ids-motion-linear);
}
.ids-slider.animated:not(.vertical) .track-progress {
  transition: transform var(--ids-motion-duration) var(--ids-motion-linear), width var(--ids-motion-duration) var(--ids-motion-linear);
}
.ids-slider.animated.vertical .track-progress {
  transition: transform var(--ids-motion-duration) var(--ids-motion-linear), height var(--ids-motion-duration) var(--ids-motion-linear);
}
.ids-slider.disabled {
  color: var(--ids-slider-color-disabled);
}
.ids-slider.disabled .label {
  cursor: default;
}
.ids-slider.disabled .tick {
  background-color: var(--ids-slider-tick-color-background-disabled);
}
.ids-slider.disabled .thumb-shadow {
  display: none;
}
.ids-slider.disabled .thumb {
  background-color: var(--ids-slider-thumb-color-background-disabled);
  cursor: default;
}
.ids-slider.disabled .thumb:hover {
  box-shadow: none;
}
.ids-slider.disabled .track-area {
  cursor: default;
}
.ids-slider.disabled .track {
  background-color: var(--ids-slider-track-color-background-disabled);
}
.ids-slider.disabled .track .threshold-segment {
  background-color: var(--ids-slider-track-color-background-progress-disabled);
}
.ids-slider.disabled .track-progress {
  background-color: var(--ids-slider-track-color-background-progress-disabled);
}
.ids-slider.readonly {
  color: var(--ids-slider-color-readonly);
}
.ids-slider.readonly .label {
  cursor: default;
}
.ids-slider.readonly .tick {
  background-color: var(--ids-slider-tick-color-background-readonly);
}
.ids-slider.readonly .thumb {
  background-color: var(--ids-slider-thumb-color-background-readonly);
  cursor: pointer;
}
.ids-slider.readonly .thumb-shadow {
  background-color: var(--ids-slider-thumb-color-shadow-readonly);
  border-color: var(--ids-slider-thumb-color-border-readonly);
  cursor: pointer;
}
.ids-slider.readonly .track {
  background-color: var(--ids-slider-track-color-background-readonly);
}
.ids-slider.readonly .track-progress {
  background-color: var(--ids-slider-track-progress-color-background-readonly);
}
.ids-slider.readonly .track-area {
  cursor: default;
}

.slider {
  display: inline-flex;
  position: relative;
  width: 92%;
  margin: 45px 4% 50px;
  justify-content: center;
  align-items: center;
}
.slider.vertical {
  height: 92%;
}
.slider.vertical .tick {
  transform: translate(0, 50%);
}
.slider .tick-container {
  display: flex;
  position: absolute;
  width: 100%;
  align-items: center;
}
.slider .tick-container.vertical {
  height: 100%;
  flex-direction: column;
  align-items: center;
}
.slider .tick {
  display: flex;
  width: var(--ids-slider-tick-size);
  height: var(--ids-slider-tick-size);
  border-radius: var(--ids-border-radius-circle);
  z-index: 40;
  justify-content: center;
  position: absolute;
  transform: translateX(-50%);
}
.slider .label {
  cursor: pointer;
  position: absolute;
  transform: translate(0, 100%);
}
.slider .label::part(text) {
  white-space: nowrap;
}
.slider .label.vertical {
  transform: translate(-50px, -25%);
  min-width: 50px;
  text-align: right;
}
.slider .tooltip {
  background-color: var(--ids-slider-tooltip-color-background);
  color: var(--ids-slider-tooltip-color-text);
  display: flex;
  justify-content: center;
  position: absolute;
  width: auto;
  padding: var(--ids-slider-tooltip-padding);
  height: auto;
  text-align: center;
  margin: auto;
  border-radius: var(--ids-border-radius-2xs);
  vertical-align: middle;
  line-height: 30px;
  max-width: 300px;
  min-width: 32px;
  transition: opacity 0.2s ease;
  opacity: 0;
  bottom: 175%;
  left: -12px;
  user-select: none;
}
.slider .tooltip.vertical {
  bottom: unset;
  left: 200%;
  transform: translate(0, -25%);
}
.slider .tooltip .pin {
  position: absolute;
  width: 0;
  height: 0;
  bottom: -6px;
  margin-top: 1px;
  left: 14px;
  border-left: 6px solid transparent;
  border-top: 6px solid var(--ids-slider-tooltip-color-background);
  border-right: 6px solid transparent;
}
.slider .tooltip .pin.vertical {
  left: unset;
  bottom: unset;
  margin-top: unset;
  border-top: 6px solid transparent;
  border-right: 6px solid var(--ids-slider-tooltip-color-background);
  border-bottom: 6px solid transparent;
  right: 100%;
  transform: translate(0, 10px);
}
.slider .thumb-draggable {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  outline: none;
  position: absolute;
  inset-inline: var(--inset-inline-start);
}
.slider .thumb {
  width: var(--ids-slider-thumb-size);
  height: var(--ids-slider-thumb-size);
  border-radius: 50%;
  z-index: 50;
}
.slider .thumb-shadow {
  position: absolute;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  border-width: var(--ids-space-4xs);
  border-style: solid;
  transition: transform var(--ids-motion-duration) var(--ids-motion-linear);
  transform: scale(0);
}
.slider .thumb-shadow.active {
  transform: scale(1);
}
.slider .track-area {
  width: 100%;
  height: var(--ids-space-md);
}
.slider .track-area.vertical {
  height: 100%;
  width: var(--ids-space-md);
}
.slider .track-area {
  background-color: var(--ids-color-transparent);
  align-items: center;
  justify-content: center;
  display: flex;
  position: absolute;
  z-index: 50;
  cursor: pointer;
}
.slider .track {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: var(--ids-space-2xs);
  width: calc(100% - var(--ids-slider-thumb-size) / 2);
}
.slider .track.vertical {
  justify-content: center;
  width: var(--ids-space-2xs);
  height: calc(100% - var(--ids-slider-thumb-size) / 2);
}
.slider .track {
  position: absolute;
  z-index: 30;
  border-radius: var(--ids-border-radius-2xs);
}
.slider .track .track-progress {
  height: inherit;
  position: absolute;
  /* stylelint-disable-next-line custom-property-pattern */
  width: calc((var(--percentEnd) - var(--percentStart)) * 1%);
}
.slider .track .track-progress.vertical {
  /* stylelint-disable-next-line custom-property-pattern */
  height: calc((var(--percentEnd) - var(--percentStart)) * 1%);
  width: 100%;
  bottom: 0%;
}

:host([dir=rtl]) .slider:not(.vertical) .tick {
  transform: translateX(50%);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
